// FILE: src/utils/seoHelpers.js

// 1. The Category Text Blocks (Solves Thin Content)
export const getCategoryText = (hsChapter) => {
  const chapter = String(hsChapter);
  
  if (['72', '73'].includes(chapter)) {
    return "The Canadian steel market is highly sensitive to cross-border volatility and LTL freight density. Sourcing high-density structural steel and rebar directly from domestic fabricators not only mitigates tariff risks but ensures 100% CFTA compliance for municipal and institutional infrastructure projects.";
  }
  
  if (chapter === '44') {
    return "Domestic lumber sourcing relies heavily on regional mill proximity to protect margins. Transporting SPF and mass timber requires specific LTL freight classifications (typically Class 70). Bypassing distributors to buy directly from regional Canadian sawmills drastically reduces landed costs while meeting green-building and CFTA mandates.";
  }
  
  if (['25', '68'].includes(chapter)) {
    return "For heavy aggregates, ready-mix concrete, and precast panels, freight costs often outweigh the baseline material value. Hyper-local sourcing is mathematically required to protect margins. Direct-to-plant procurement eliminates distributor markups and ensures compliance with regional environmental and structural standards.";
  }

  return "Sourcing industrial materials directly from Canadian fabricators ensures CFTA compliance, reduces cross-border tariff risks, and eliminates standard 15-20% distributor markups for mid-to-large General Contractors.";
};

// 2. The JSON-LD Schema Generator (Captures Google "People Also Ask" boxes)
export const generateFaqSchema = (masterKeyword) => {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": `How can I source ${masterKeyword} directly from Canadian fabricators?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `General Contractors can bypass distributor markups on ${masterKeyword} by using direct-sourcing platforms to route Purchase Orders straight to regional Canadian plants and mills.`
        }
      },
      {
        "@type": "Question",
        "name": `What is the compliance requirement for ${masterKeyword} in public projects?`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": `When sourcing ${masterKeyword} for municipal or hospital projects, estimators must ensure the supply chain complies with CFTA regulations and regional trade agreements.`
        }
      }
    ]
  });
};